import { render, staticRenderFns } from "./DecoArrangerItem.vue?vue&type=template&id=488e9d5a&"
import script from "./DecoArrangerItem.vue?vue&type=script&lang=ts&"
export * from "./DecoArrangerItem.vue?vue&type=script&lang=ts&"
import style0 from "./DecoArrangerItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports